export const MODAL_NAME = 'orders.fix-order-issue'

export const ISSUES = {
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  DELIVERY_ISSUE: 'DELIVERY_ISSUE',
  OTHER_ISSUE: 'OTHER',
} as const
